import { API_ENDPOINT } from "@/constants/appConstants";
import { APPLIED_JOBS_QUERY_KEY } from "@/lib/queryKeys";
import {
  UseInfiniteQueryResult,
  useInfiniteQuery,
} from "@tanstack/react-query";

import { AppliedPageAPIResponseType } from "./types";

export const appliedJobAPI = async (
  filterUuid?: string,
  pageParam: number = 1,
  limit: number = 10,
): Promise<AppliedPageAPIResponseType> => {
  try {
    const host = window.location.host;
    const response = await fetch(
      `${API_ENDPOINT(host).middleware.getAppliedJobData}?${filterUuid ? `filterStatus=${filterUuid}&` : ""}start=${(pageParam - 1) * limit}&limit=${limit}`,
      {
        method: "GET",
        credentials: "include",
      },
    );

    const data = await response.json();
    return data;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(
        `Error occurred while fetching data, ${JSON.stringify(error)}`,
      );
    }
  }
};

export const useAppliedJobs = (
  filterStatus: string,
  enableToggle: boolean,
  initialPage: number,
): UseInfiniteQueryResult<{ pages: AppliedPageAPIResponseType[] }> => {
  return useInfiniteQuery({
    queryKey: [APPLIED_JOBS_QUERY_KEY, filterStatus, initialPage],
    queryFn: ({ pageParam }) => {
      return appliedJobAPI(filterStatus, pageParam, 10);
    },
    getNextPageParam: (lastPage, allPages) => {
      const currentPage =
        initialPage == 2 ? allPages.length + 1 : allPages.length;
      return currentPage + 1;
    },
    initialPageParam: initialPage,
    enabled: enableToggle,
  });
};
